import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RedirectPage() {
  const { handle, slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const path = slug ? `${handle}/${slug}` : handle;
    axios.post(`${API}/r/${path}`, { referrer: document.referrer }, { withCredentials: true })
      .then((r) => window.location.replace(r.data.url))
      .catch(() => navigate("/", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
